import { rosterAPI } from '@/providers/apis/roster/roster';
import { copy } from '@/utils/cohort';
import { STATUS_CODE_MESSAGE } from '@/utils/constants';
import { isAPICatchError } from '@/utils/utils';
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'user-details',
})

export default class UserDetails extends Vue {


    // ------------------------------------------------------------------------
    // Properties
    @Prop()
    private activeRoster: any;

    @Prop({default: false})
    private showSourceId: any;

    private usersList: any = [];

    private isLoading: boolean = false;

    private statusCode: any = STATUS_CODE_MESSAGE;

    private tableFields: any = [
        {
            key: 'identifier',
            label: 'UDISE / NCES ID',
        },
        {
            key: 'givenName',
            label: 'First Name',
        },
        {
            key: 'familyName',
            label: 'Last Name',
        },
        {
            key: 'username',
            label: 'Username',
        }, {
            key: 'email',
            label: 'Email',
        },
        {
            key: 'syncStatusCode',
            label: 'Status',
        },
        {
            key: 'role', // 'organizationType',
            label: 'Role',
        },
        {
            key: 'syncStatusMessage.message',
            label: 'Errors',
        },
        {
            key: 'sourcedId',
            label: 'Sourced Id',
        },
    ];

    private offset: number = 0;

    private limit: number = 10;

    private totalLength: number = 0;

    private currentPage: number = 1;

    private pageLimit: number = 10;

    public get filteredItemList() {
        const tableFields = copy(this.tableFields);
        return tableFields.filter((item: any) => {
            if (this.showSourceId) {
                return tableFields;
            } else {
               return item.key !== 'sourcedId';
            }
        });
    }

    // ---------------------------------------------------------------------------------
    // Hooks

    private created() {
        this.isLoading = true;
        if (!this.activeRoster.showError) {
            const errorIndex = this.tableFields.findIndex((item: any) => item.label === 'Errors');
            if (errorIndex !== -1) {
                this.tableFields.splice(errorIndex, 1);
            }
        }
        this.fetchClasslist();
    }

    // ---------------------------------------------------------------------------------
    // Actions

    private onSelectPage(item: any) {
        this.isLoading = true;
        this.currentPage = item;
        this.offset = (item - 1) * this.pageLimit;
        this.fetchClasslist();
    }

    // ------------------------------------------------------------------------------
    // Methods

    private fetchClasslist() {
        const params = {
            zipId: this.activeRoster.id,
            offset: this.offset,
            limit: this.pageLimit,
            is_required_sync: this.activeRoster.showError,
        };

        rosterAPI.getRosterUsers(params).then((usersList) => {
            this.isLoading = false;
            if (!isAPICatchError(usersList)) {
                this.usersList = usersList.users;
                this.totalLength = usersList.totalUsersCount;
            }
        });
    }

}
